import css from 'styled-jsx/css';

const styles = css`:root {
  /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */
  --black: #000000;
  --dark-gray: #b3b3b3;
  --error: red;
  --success: #248647;
  --green: green;
  --lightgreen: lightgreen;
  --gray-1: #787778;
  --gray-2: #bbbbbb;
  --gray-2-5: #d8d8d8;
  --gray-3: #eeeeee;
  --gray-4: #f8f8f8;
  --gray-5: #fafafa;
  --gray-6: #ebebeb;
  --gray-footer: #4f4f4f;
  --gray-footer-text: #757575;
  --gray-black: #111111;
  --heading-gray: #505050;
  --border-gray: #c8c8c8;
  --gray-background: rgba(0, 0, 0, 0.2);
  --warning: #daaa00;

  --mmr-yellow: #f8e71c;
  --mmr-red: #b41f00;
  --module-gray: #f7f7f7;
  --module-white: #ffffff;
  --primary-bg: #eeeeee;
  --clear: transparent;

  --risk-high: #e37a00;
  --risk-low: #7c993f;
  --risk-med: #ffcc00;
  --text-fg: #3b3b3b;
  --text-header: #4c5a6a;
  --tooltip-header: #4c5a69;
  --warm-grey: #898989;
  --white: #ffffff;
  --border-line: #b8b8b8;
  --orange-button: #e17a17;

  --text-dark: #3b3b3b;
  --text-med: #4f4f4f;
  --text-light: #898989;
  --text-xlight: #c4c4c4;
  --text-disabled: #b1b1b1;

  --subtle-blue-gray: #f7f9fa;
  --trp-dark-blue: #004b71;
  --trp-light-blue: #eef7fa;
  --trp-bright-blue: #05c3de;
  --ice-blue: #24c0d8;
  --row-blue: #06c3df;
  --trp-dark-blue: #0063ad;
  --dark-blue: #054c70;
  --dark-blue-2: #043954;
  --navy-blue: #0a4c71;
  --trp-nav-dark-blue: #061937;
  --trp-bottom-footer-blue: #0c2a4d;
  --trp-link-blue: #80c8ff;
  --trp-tag-blue: #00cfec;

  --navy-gradient: linear-gradient(115deg, #054c70, #086ea1);

  /* NASU Specifc Colors */
  /* TODO [2020-08-05]: change these colors to EDDS approved colors if they are not already */
  --BYOP-header-grey: #f0f3f5;
  --BYOP-header-contents-grey: #f7f9fa;

  /* 2020 colors */
  --primary-blue: #086ea1;
  --brand-interactive-blue: #006894;
  --grey-text: #475359;
  --gray-back: #f1f1f1;
  --gray-morningstar: #6b7880;
  --gray-non-rated-star: #b4babf;
  --gray-risk-reward-bar: #e9edf0;
  --green-risk-reward-thumb: #7d9845;
  --yellow-risk-reward-thumb: #ffcf3d;
  --orange-risk-reward-thumb: #e17a17;
  --gray-header-bottom-border: #879199;
  --gray-disabled-button: #e1e5e8;
  --border-white: #d3d7da;
  --link-blue: #006894;
  --qv-header-bottom-border: #d7dbde;
  --required-error-msg: #cc1f1f;
  --no-funds-error-msg: #dd3636;

  /* Beacon colors */
  --beacon-primary: #8b57d9;
  --input-field-title: #3b4b59;
  --background-blue: #253746;
}
:root {
  --page-max-width: 1230px;
  --page-padding: 32px;
  --module-gutter: 24px;
  --half-gutter: calc(var(--module-gutter) / 2);
  --quarter-gutter: calc(var(--half-gutter) / 2);
  --module-padding: 24px;
  --mobile-padding: 4px;
  --min-content: min-content;

  /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */
  --element-spacing-1: 8px;
  --element-spacing-2: calc(var(--element-spacing-1) * 2);
  --element-spacing-3: calc(var(--element-spacing-1) * 3);
  --element-spacing-4: calc(var(--element-spacing-1) * 4);
  --element-spacing-5: calc(var(--element-spacing-1) * 5);
  --element-spacing-6: calc(var(--element-spacing-1) * 6);
  --element-spacing-7: calc(var(--element-spacing-1) * 7);
  --element-spacing-8: calc(var(--element-spacing-1) * 8);
  --element-spacing-9: calc(var(--element-spacing-1) * 9);
  --element-spacing-10: calc(var(--element-spacing-1) * 10);
  --element-spacing-11: calc(var(--element-spacing-1) * 11);

  --border-thin-width: 1px;
  --border-width: 2px;
  --border-radius: 5px;

  /* New II Design Pattern - Introduced 11-12-2019 */
  --page-focus-width: 544px;
  --help-focus-width: 328px;
}
:root {
  --xxxsmall-font: 10px;
  --xxsmall-font: 12px;
  --xsmall-font: 14px;
  --small-font: 16px;
  --med-font: 18px;
  --large-font: 20px;
  --xlarge-font: 24px;
  --xxlarge-font: 36px;
  --xxxlarge-font: 48px;
  --title-font: 18px;
  --label-sup-font: 100%;

  --h1-font: 32px;
  --h2-font: 20px;
  --p1: 16px;
  --p2: 14px;
  --caption-size: 12px;

  --h1-font-mobile: 24px;
  --h2-font-mobile: 18px;
  --p1-mobile: 16px;
  --p2-mobile: 14px;
  --caption-size-mobile: 12px;

  --roboto-flex-font: 'Roboto Flex', sans-serif;
  --sans-novus: 'Roboto Flex Novus';
  --condensed-font: 'Roboto Flex Condensed', 'Roboto Flex', sans-serif;
  --condensed-bold: 'Roboto Flex Condensed Bold', 'Roboto Flex Condensed',
    sans-serif;
  --serif-font: 'IBM Plex Serif', serif;
  --mono-font: 'Roboto Flex', sans-serif;

  --roboto-reg: 'Roboto Flex Reg', sans-serif;
  --roboto-italic: 'Roboto Flex Italic', sans-serif;
  --roboto-bold: 'Roboto Flex Bold', sans-serif;
  --roboto-light: 'Roboto Flex', sans-serif;
  --roboto-black: 'Roboto Flex Black', sans-serif;

  --rocky-reg: 'Rocky Reg', sans-serif;
  --rocky-light: 'Rocky Light', sans-serif;

  --regular-weight: 400;
  --bold-weight: 700;
  --light-weight: 100;
  --normal-weight: normal;

  --checkbox-height: 25px;
  --checkbox-width: 25px;
}
:root {
  --icon-right-margin: 3px;
  --icon-height: 30px;
  --submission-time-padding-top: 21px;
  --investment-info-padding-left: 50px;
  --cost-basis-header-width: 800px;
  --media-cost-basis-header-width: 300px;
}
.next-instructions {
  padding: calc(8px * 2) calc(8px * 4);
  background: #f7f9fa;
  margin: 0 auto;
  font-family: 'Roboto Flex', sans-serif;
  font-weight: 100;
  font-size: 16px;
}
.step-contents {
  padding: calc(8px * 2);
  background: #ffffff;
}
.non-funded-list-item {
  margin-left: 0;
}
section.pending-transaction {
  padding: calc(8px * 3) calc(8px * 4) 0
    calc(8px * 4);
}
.download-icon {
  display: inline-block;
  width: calc(8px * 2);
  height: calc(8px * 2);
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg version='1.1' preserveAspectRatio='none' viewBox='0 -52.41490262489418 684 684' class='ng-element' data-id='e64440f70fed60fc84c092f02759103a' style='fill: rgb%284%2C 88%2C 146%29%3B width: 24px%3B height: 24px%3B' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Cg xmlns:default='http://www.w3.org/2000/svg'%3E%3Crect y='552.5' width='684' height='26.3' style='fill: rgb%284%2C 88%2C 146%29%3B'/%3E%3Cpolygon points='523.6%2C313.1 502.5%2C292 355.2%2C442 355.2%2C0 328.9%2C0 328.9%2C442 181.5%2C292 160.5%2C313.1 342%2C492 ' style='fill: rgb%284%2C 88%2C 146%29%3B'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  margin-right: 8px;
}
.check-mark-icon {
  position: relative;
  top: 10px;
  padding-right: 8px;
}
.time-clock-icon {
  position: relative;
  top: 10px;
  padding-right: 8px;
}
.confirm-page-icon-headers {
  display: inline-block;
}
.transaction-headers {
  font-weight: bold;
}
.transaction-info {
  display: flex;
}
.submission-time-info {
  padding-top: 21px;
  padding-left: calc(8px * 4);
}
.transaction-submission-time-info {
  padding-top: 21px;
  padding-left: calc(8px * 5);
}
.account-number-info {
  padding-bottom: calc(8px * 2);
}
.investments-info {
  padding-left: 50px;
}
.cost-basis-info {
  padding-left: calc(8px * 4);
}
h3 {
  font-family: 'Roboto Flex', sans-serif;
  font-weight: 100;
  font-size: 20px;
}
h4 {
  margin-bottom: 0;
}
.bouncing-transfer-form-text {
  color: #006894;
  font-weight: bold;
  animation: bounce 1s infinite;
}
.cost-basis-headers {
  width: 800px;
}
@media (min-width: 722px) {
  .cost-basis-headers {
    width: 300px;
  }
}
.date-created-header {
  padding-right: calc(8px * 2);
}
.investments-headers {
  padding-right: 8px;
}
@media (min-width: 722px) {
  .date-created-header {
    padding-right: calc(8px * 4);
  }
  .investments-headers {
    padding-right: calc(8px * 4);
  }
}
@media (prefers-reduced-motion: reduce) {
  .bouncing-transfer-form-text {
    animation: none;
  }
}
@keyframes bounce {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
.download-form {
  margin-top: calc(8px * 3);
  display: flex;
  align-content: center;
  cursor: pointer;
}
a {
  color: #006894;
  font-weight: bold;
  text-decoration: none;
}
a.underlined-confirmation-links {
  text-decoration: underline;
}
.option-text {
  font-weight: bold;
}
.qv-row {
  display: flex;
  flex-wrap: wrap;
}
.qv-row + .qv-row {
  margin-top: calc(8px * 2);
}
.qv-col {
  width: 100%;
}
.qv-col + .qv-col {
  margin-top: calc(8px * 2);
}
.disclaimer {
  margin: calc(8px * 2);
  font-weight: bold;
}
li {
  margin-bottom: calc(8px * 2);
}
.bank-verification-info li {
  margin-bottom: 8px;
}
@media (min-width: 722px) {
  .qv-row + .qv-row {
    margin-top: calc(8px * 3);
  }

  .qv-col {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .qv-col + .qv-col {
    margin-top: 0;
    margin-left: calc(8px * 2);
  }
}
.icon {
  display: inline-block;
  margin-right: 3px;
  width: calc(8px * 3);
  height: 30px;
  background-repeat: no-repeat;
}
.call-icon {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='xMidYMid meet' viewBox='0 0 24 24' class='ng-element' data-id='7ca6a71c51d14eaf93fb391be60029be' style='fill: rgb%284%2C 88%2C 146%29%3B width: 32px%3B height: 32px%3B filter: none%3B'%3E%3Cg%3E%3Cpath xmlns:default='http://www.w3.org/2000/svg' id='phone' d='M19.33%2C16.26c0.01-0.07%2C0.01-0.15%2C0-0.22c-0.21-0.25-0.48-0.44-0.79-0.55l-0.56-0.31l-0.66-0.36l-0.56-0.32 l-0.26-0.18c-0.12-0.08-0.24-0.16-0.37-0.22c-0.1-0.06-0.21-0.09-0.33-0.09c-0.2%2C0.03-0.39%2C0.14-0.52%2C0.3 c-0.21%2C0.2-0.4%2C0.42-0.57%2C0.65c-0.17%2C0.23-0.35%2C0.45-0.55%2C0.65c-0.12%2C0.16-0.29%2C0.26-0.48%2C0.3c-0.08%2C0-0.16-0.02-0.23-0.05 l-0.21-0.09L13%2C15.61l-0.2-0.12c-0.9-0.49-1.72-1.1-2.45-1.81c-0.71-0.73-1.32-1.55-1.81-2.45L8.4%2C11.01l-0.15-0.25 c-0.03-0.07-0.06-0.14-0.09-0.21c-0.03-0.07-0.05-0.15-0.05-0.23c0.04-0.19%2C0.14-0.36%2C0.3-0.48c0.2-0.2%2C0.42-0.38%2C0.65-0.55 C9.29%2C9.12%2C9.5%2C8.93%2C9.7%2C8.73C9.86%2C8.6%2C9.97%2C8.41%2C10%2C8.21c0-0.1-0.02-0.21-0.07-0.3C9.86%2C7.78%2C9.79%2C7.66%2C9.7%2C7.54L9.52%2C7.28 L9.2%2C6.73L8.83%2C6.07L8.52%2C5.5C8.42%2C5.2%2C8.24%2C4.92%2C8%2C4.71c-0.07-0.01-0.15-0.01-0.22%2C0c-0.25%2C0.01-0.49%2C0.04-0.73%2C0.1 C6.79%2C4.85%2C6.54%2C4.92%2C6.3%2C5.01c-0.49%2C0.3-0.87%2C0.74-1.1%2C1.26C4.86%2C6.86%2C4.68%2C7.53%2C4.67%2C8.21c-0.01%2C0.18-0.01%2C0.37%2C0%2C0.55 c0.03%2C0.2%2C0.07%2C0.4%2C0.13%2C0.6C4.89%2C9.58%2C4.95%2C9.74%2C5%2C9.85l0.2%2C0.58l0.19%2C0.51c0.22%2C0.64%2C0.51%2C1.25%2C0.86%2C1.82 c0.64%2C1%2C1.4%2C1.92%2C2.25%2C2.75c0.83%2C0.85%2C1.75%2C1.61%2C2.75%2C2.25c0.57%2C0.35%2C1.18%2C0.64%2C1.82%2C0.86l0.51%2C0.19l0.58%2C0.2l0.49%2C0.15 c0.2%2C0.06%2C0.4%2C0.1%2C0.6%2C0.13c0.18%2C0.01%2C0.37%2C0.01%2C0.55%2C0c0.68-0.01%2C1.35-0.19%2C1.94-0.53c0.52-0.22%2C0.95-0.58%2C1.26-1.05 c0.1-0.23%2C0.17-0.46%2C0.23-0.7c0.06-0.24%2C0.09-0.48%2C0.1-0.73l0%2C0V16.26z' style='fill: rgb%284%2C 88%2C 146%29%3B'/%3E%3C/g%3E%3C/svg%3E");
}
.calendar-icon {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='xMidYMid meet' viewBox='0 0 24 24' class='ng-element' data-id='d656c757d5924e559c92fd263d613d77' style='fill: rgb%284%2C 88%2C 146%29%3B width: 32px%3B height: 32px%3B filter: none%3B'%3E%3Cg%3E%3Cpath xmlns:default='http://www.w3.org/2000/svg' id='calendar' d='M4.67%2C17h3v3h-3V17z M8.33%2C17h3.33v3H8.34v-3H8.33z M4.67%2C13h3v3.33h-3V13z M8.33%2C13h3.33v3.33H8.34V13H8.33z M4.67%2C9.33h3v3h-3V9.33z M12.33%2C17h3.33v3h-3.33V17z M8.33%2C9.34h3.33v3H8.34v-3H8.33z M16.33%2C17h3v3h-3V17z M12.33%2C13h3.33v3.33 h-3.33V13z M8.57%2C7.57c-0.06%2C0.06-0.14%2C0.1-0.23%2C0.1H7.67C7.49%2C7.66%2C7.35%2C7.52%2C7.34%2C7.34v-3c0-0.18%2C0.15-0.33%2C0.33-0.34h0.67 c0.18%2C0.01%2C0.32%2C0.15%2C0.33%2C0.33v3C8.67%2C7.42%2C8.64%2C7.51%2C8.57%2C7.57z M16.33%2C13h3v3.33h-3V13z M12.33%2C9.34h3.33v3h-3.33V9.34z M16.33%2C9.34h3v3h-3V9.34z M16.56%2C7.58c-0.06%2C0.06-0.14%2C0.1-0.23%2C0.1h-0.67c-0.18-0.01-0.32-0.15-0.33-0.33v-3 C15.32%2C4.16%2C15.47%2C4.01%2C15.66%2C4c0%2C0%2C0%2C0%2C0%2C0h0.67c0.18%2C0.01%2C0.32%2C0.15%2C0.33%2C0.33v3c0%2C0.09-0.03%2C0.18-0.09%2C0.24L16.56%2C7.58z M20.66%2C6.68c-0.01-0.73-0.6-1.32-1.33-1.33H18v-1c0-0.92-0.75-1.67-1.67-1.67l0%2C0h-0.67C14.75%2C2.69%2C14.01%2C3.43%2C14%2C4.34v1h-4v-1 c0-0.92-0.74-1.66-1.66-1.67H7.67C6.75%2C2.67%2C6%2C3.42%2C6%2C4.34l0%2C0v1H4.67c-0.73%2C0.01-1.32%2C0.6-1.33%2C1.33V20 c0.01%2C0.73%2C0.6%2C1.32%2C1.33%2C1.33h14.66c0.73-0.01%2C1.32-0.6%2C1.33-1.33V6.68L20.66%2C6.68L20.66%2C6.68z' style='fill: rgb%284%2C 88%2C 146%29%3B'/%3E%3C/g%3E%3C/svg%3E");
}
.call-options-wrapper {
  display: flex;
}
.icon-wrapper {
  display: flex;
  align-items: center;
  height: 30px;
}
.call-options h3 {
  margin: 0;
}
.call-option {
  margin: calc(8px * 2);
}
.call-option-separator {
  margin: calc(8px * 2);
}
.call-option-separator {
  display: flex;
  align-items: center;
}
.call-option {
  border-radius: 5px;
  border: 1px solid #bbbbbb;
  padding: calc(8px * 2);
}
.contact-info-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: calc(8px * 5);
}
.option-subtitle {
  color: #787778;
}
.address {
  font-weight: 700;
}
@media (min-width: 322px) and (max-width: 720px) {
  .contact-info-wrapper,
  .call-options-wrapper {
    flex-direction: column;
  }
}
.confirmation-section-headers {
  font-weight: bold;
}
`;

export default styles;